import { render, staticRenderFns } from "./unauthorised-restrictive-practice.vue?vue&type=template&id=f5e79be0&scoped=true"
import script from "./unauthorised-restrictive-practice.vue?vue&type=script&lang=js"
export * from "./unauthorised-restrictive-practice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e79be0",
  null
  
)

export default component.exports